import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({providedIn: 'root'})

export class UtilService {
  private _httpClient: HttpClient = inject(HttpClient);

  public getFaqs(): Observable<any> {
    return this._httpClient.get('data/faqs.json');
  }

  public getTermsOfUse(): Observable<any> {
    return this._httpClient.get(environment.apiUrl + environment.treatmentApi + 'files/public-documents/terms-of-use.html');
  }

  public getPrivacyPolicy(): Observable<any> {
    return this._httpClient.get(environment.apiUrl + environment.treatmentApi + 'files/public-documents/privacy-policy.html');
  }
}
